// SINGLE FIELD VALIDATORS
import { FormControl, FormGroup } from "@angular/forms";
import { Observable } from 'rxjs/Rx';

export function emailValidator(control: FormControl): { [key: string]: any } {
  var emailRegexp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  let result = false;
  if (control.value && !emailRegexp.test(control.value)) {
    result = true;
  }
  return Observable.of(result ? { invalidEmail: true } : null);
}

export function noWhitespaceValidator(control: FormControl) {
  let isWhitespace = (control.value || '').trim().length === 0;
  return Observable.of(isWhitespace ? { 'whitespace': true } : null);
}

// FORM GROUP VALIDATORS
export function matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
  return (group: FormGroup): { [key: string]: any } => {
    let password = group.controls[passwordKey];
    let confirmPassword = group.controls[confirmPasswordKey];

    return {
      mismatchedPasswords: password.value !== confirmPassword.value
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/validators/validators.ts